import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Alert from 'components/ui/Alert';
import OrderRtbBanner from './OrderRtbBanner';
import _ from 'underscore';
import { isNil } from 'lodash';
import { humanize } from 'underscore.string';
import marked from 'marked';
import moment from 'moment';
import { arrayMove } from 'react-sortable-hoc';
import unitConverter from 'convert-units';
import { Menu } from '@headlessui/react';
import Badge from 'components/v2/Badge';
import DropdownMenu from 'components/v2/dropdowns/DropdownMenu';
import DropdownItem from 'components/v2/dropdowns/DropdownItem';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import DriverActionCreators from 'actions/DriverActionCreators';
import Accounting from 'components/modules/shipments/accounting/Accounting';
import PortIntegration from 'components/modules/equipment/PortIntegration';
// import { LegNumberSummary } from './LegNumberSummary/LegNumberSummary';
import StatusBar from 'components/modules/shipments/StatusBar';
import CloneShipmentModal from 'components/modules/shipments/CloneShipmentModal';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import CommentList from 'components/modules/comments/CommentList';
import ShipmentStore from 'stores/ShipmentStore';
import SessionStore from 'stores/SessionStore';
import DriverStore from 'stores/DriverStore';
import { showToast } from 'stores/ToastStore';
import ExceptionStore from 'stores/ExceptionStore';
import { getLatestStatus } from 'utils/formatters/shipments';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
import {
  approveCarrierCost,
  removeLineItem,
} from 'utils/AccountingWebAPIUtils';
import {
  getAccessorialRequestsAutoDeclineDates,
  resolveAccessorialsStatus,
} from 'utils/AccessorialRequestWebAPIUtils';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
// CargomaticTooltip replaced with @cargomatic/ui Tooltip
import FetchWebAPIUtils from 'utils/FetchWebAPIUtils';
import CargomaticPane from 'components/v2/pane';
import { getShipmentTimezone, isShipmentCanceled } from 'helpers/shipments';
import { isLegManagementEnabled } from 'helpers/legs-helper';
import ShipmentWebAPIUtils, { addHold } from 'utils/ShipmentWebAPIUtils';
import { withTranslation } from 'react-i18next';
import { INTERMODAL_TYPES } from 'constants/ShipmentTypes';
import { withLocaleContext } from 'providers/locale-settings-context';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import {
  userCanApproveAccessorials as userCanApproveAccessorialsHelper,
  checkIfAccessorialsNeedsReview,
  checkIfEquipmentIsMissing,
} from 'helpers/accessorials';
import MarketplaceStatus from './MarketplaceStatus';
import SendDOEmailModal from './SendDOEmailModal';
import SendBolEmailModal from './SendBOLEmailModal';
import SendRATEEmailModal from './SendRATEEmailModal';
import SendEmailModal from './SendEmailModal';
import ShipmentDetails from './ShipmentDetails';
import ShipmentRoute from './ShipmentRoute';
import AssignDriverModal from './AssignDriverModal';
import ConfirmAssignCarrierModal from './ConfirmAssignCarrierModal';
import AddAccessorialModal from './accounting/AddAccessorialModal';
import AddOrAdjustDrayageAccessorialModal from './accounting/AddOrAdjustDrayageAccessorialModal';
import CancelShipmentModal from './CancelShipmentModal';
import AddIncentiveModal from './accounting/AddIncentiveModal';
import ShipmentReopenModal from './ShipmentReopenModal';
import GenerateLedgerModal from '../orders/accounting/GenerateLedgerModal';
import RerateCostModal from '../orders/accounting/RerateCostModal';
import AccessorialRequests from './accessorials/AccessorialRequests';
import {
  isDrayageOrRailShipment,
  isIntermodalShipmentType,
} from '../../../helpers/shipment-types';
import BulkAddAccessorialsModal from './accounting/BulkAddAccessorialsModal';
import AccessorialRequestPane from './AccessorialRequestPane';
import { getDeliveryOrderRecipients } from '../../../helpers/shipments';
import AccessorialsConfirmationModal from './accessorials/ConfirmationModal';
import ShipmentStateDefinition from '../../../config/shipment-state-definitions';
import {
  generateOrderInvoice,
  generateOrderPayout,
} from '../../../utils/OrderWebAPIUtils';
import AddButton from '../../v2/buttons/AddButton';
import Events from './events/Event';
import { RECEIVABLES } from '../../../constants/LedgerTypes';
import ShipmentHolds from './ShipmentHolds';
import ShipmentOnHoldModal from './ShipmentOnHoldModal';
import ShipperCostAdjustmentModel from './accounting/ShipperCostAdjustmentModel';
import { Documents } from '../documents/Documents';
import { ShipmentInvoiceDocumentPreferences } from './ShipmentInvoiceDocumentPreferences';
import MeteringTable from './MeteringTable';
import { OverrideBillingStatusModal } from './OverrideBillingStatusModal';
import { BillingStatusPendingReviewModal } from './BillingStatusPendingReviewModal';
import {
  getUserInvoiceSettings,
  getPendingAccessorialInclusion,
} from 'utils/UserServiceAPIUtils';
import ShipmentBridges from 'components/modules/shipments/ShipmentBridges.js';
import { FloatingAIAssistant } from './assistant/AIAssistant';
import {
  Button as ShadcnButton,
  Card,
  CardContent,
  DropdownMenu as ShadcnDropdownMenu,
  DropdownMenuContent as ShadcnDropdownMenuContent,
  DropdownMenuItem as ShadcnDropdownMenuItem,
  DropdownMenuTrigger as ShadcnDropdownMenuTrigger,
  Tooltip as ShadcnTooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@cargomatic/ui';
import { ChevronDown as ShadcnChevronDown, Info } from 'lucide-react';
// import { Sparkle } from 'lucide-react';
import HazmatDetails from '../orders/HazmatDetailsList';
// Removed feature-flag gates; using shipment.leg_management_version toggles instead

marked.setOptions({
  renderer: new marked.Renderer(),
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: true,
  smartLists: true,
  smartypants: false,
});

const CARGOMATIC = 'Cargomatic Inc.';

function clearMessage(shipmentId, index) {
  return () => {
    ShipmentsActionCreators.clearMessage(shipmentId, index);
  };
}

class Shipment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdmin: SessionStore.isAccessorialsAdmin(),
      showHoldModal: false,
      showOverrideBillingStatusModal: false,
      showBillingStatusPendingReviewModal: false,
      showAddAccessorialModal: false,
      showSendDOEmailModal: false,
      showSendFeesDueEmailModal: false,
      showSendBOLEmailModal: false,
      showSendRATEEmailModal: false,
      showAddOrAdjustDrayageAccessorialModal: false,
      showShipperChargeAdjustmentModal: false,
      showIncentiveModal: false,
      showAssignDriverModal: false,
      showConfirmAssignCarrierModal: false,
      showCloneShipmentModal: false,
      showCancelShipmentModal: false,
      showShipmentReOpenModal: false,
      showRerateCostModal: false,
      showConfirmModal: false,
      showConfirmRemoveModal: false,
      showConfirmStateTransitionModal: false,
      shipment: null,
      timezone: 'America/Los_Angeles',
      isLoadingHolds: false,
      stops: [],
      audits: [],
      waypoints: [],
      waypointsEnabled: false,
      customAdjustment: null,
      confirmModalMessage: '',
      confirmModalTitle: '',
      progress: {},
      regress: {},
      nextState: {},
      selectedAccessorialRequests: [],
      showAccessorialRequestPane: false,
      selectedAccessorialRequest: null,
      selectedLineItemForCredit: null,
      selectedLineItemForAdjustment: null,
      disableSaveCreateCreditMemoButton: false,
      documentsRefetch: null,
      accessorials: [],
      accessorialRequestIds: [],
      brokerCarrierDriver: null,
      shouldDisableAllAccessorialActions: true,
      bulkAccessorialModalEditMode: false,
      shipperInvoiceSettings: null,
      pendingAccessorialInclusion: false,
      missingReferenceNumbersList: [],
    };
  }

  componentDidMount() {
    this.getAccessorials();
    const id = getIdParam(this.props);
    ShipmentsActionCreators.getShipmentAuditEvents(id);

    ShipmentsActionCreators.getShipmentV2(id);
    ShipmentStore.addChangeListener(this._onChange);
    ShipmentStore.addShipmentAuditsChangeListener(this._onAuditsChange);
    DriverStore.addChangeListener(this._onDriverWaypoints);
    ShipmentStore.addAdjustmentsChangeListener(this.handleAdjustmentsUpdate);
    ShipmentStore.addAccessorialChangeListener(this.handleAccessorialError);
    ExceptionStore.addChangeListener(this.handleAccessorialRequestChange);
  }

  componentDidUpdate(prevProps, prevState) {
    const getAccessorialConditionList = [
      getIdParam(this.props) !== getIdParam(prevProps),
      prevState?.shipment?.status !== this.state?.shipment?.status,
      prevState?.shipment?.carrier?._id !== this.state?.shipment?.carrier?._id,
      prevState?.shipment?.receivables?.length !==
        this.state?.shipment?.receivables?.length,
      prevState?.shipment?.payables?.length !==
        this.state?.shipment?.payables?.length,
    ];
    if (prevState?.shipment) {
      getAccessorialConditionList.push(
        this.checkNewlyProcessedLedgerItems(
          prevState?.shipment,
          this.state?.shipment,
          'receivables',
        ),
      );
      getAccessorialConditionList.push(
        this.checkNewlyProcessedLedgerItems(
          prevState?.shipment,
          this.state?.shipment,
          'payables',
        ),
      );
    }
    if (getAccessorialConditionList.includes(true)) this.getAccessorials();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.shipment) {
      if (
        nextProps.shipment &&
        nextProps.shipment._id !== this.state.shipment._id
      ) {
        return this.getShipment(nextProps.shipment._id);
      }

      if (
        nextProps.match?.params?.id &&
        this.props?.match?.params?.id !== nextProps.match?.params?.id
      ) {
        return this.getShipment(nextProps.match.params.id);
      }
    }
  }

  componentWillUnmount() {
    ShipmentStore.removeChangeListener(this._onChange);
    ShipmentStore.removeShipmentAuditsChangeListener(this._onAuditsChange);
    DriverStore.removeChangeListener(this._onDriverWaypoints);
    ShipmentStore.removeAdjustmentsChangeListener(this.handleAdjustmentsUpdate);
    ShipmentStore.removeAccessorialChangeListener(this.handleAccessorialError);
    ExceptionStore.removeChangeListener(this.handleAccessorialRequestChange);
    document.title = CARGOMATIC;
  }

  getAccessorials = () => {
    AccessorialRequestActionCreators.getAccessorialRequests({
      shipment: getIdParam(this.props),
    });
  };

  checkNewlyProcessedLedgerItems = (prevShipment, newShipment, ledger) => {
    const prevProcessedLedgerItems = (prevShipment[ledger] || [])?.filter(
      (item) => item?.processed,
    );
    const newProcessedLedgerItems = (newShipment[ledger] || [])?.filter(
      (item) => item?.processed,
    );
    return prevProcessedLedgerItems?.length !== newProcessedLedgerItems?.length;
  };

  handleAccessorialRequestChange = async () => {
    if (getIdParam(this.props)) {
      const shipmentId = getIdParam(this.props);
      const accessorialRequests =
        ExceptionStore.getShipmentAccessorialRequests(shipmentId);
      const accessorialRequestIds =
        getAccessorialRequestIds(accessorialRequests);

      let shipperAutoDeclineDates = {};
      const accessorialIdsWithMissingDocs =
        getAccessorialRequestIdsWithMissingDocs(accessorialRequests);
      if (accessorialRequests && accessorialRequests.length > 0) {
        if (
          featureEnabled(CONFIGURED_FEATURES.SSR) &&
          isIntermodalShipmentType(this.state.shipment) &&
          accessorialIdsWithMissingDocs?.length
        ) {
          shipperAutoDeclineDates = await this.getShipperAutoDeclineDates(
            accessorialIdsWithMissingDocs,
          );
        }
        const accessorials = accessorialRequests.map((ar) => {
          const shipperAutoDeclineDate =
            shipperAutoDeclineDates[ar._id.toString()];

          return {
            ...ar,
            shipperAutoDeclineDate,
          };
        });
        this.setState({ accessorials, accessorialRequestIds });
      } else {
        this.setState({ accessorials: [], accessorialRequestIds: [] });
      }
    }
  };

  getShipperAutoDeclineDates = async (accessorialRequestIds) => {
    const { t } = this.props;
    try {
      const result = await getAccessorialRequestsAutoDeclineDates(
        accessorialRequestIds,
      );
      const items = result?.entity?.items || [];

      return items.reduce((dates, { _id, shipper_auto_decline_date }) => {
        dates[_id] = shipper_auto_decline_date;
        return dates;
      }, {});
    } catch (e) {
      showToast(
        t('ACCESSORIAL_REQUEST_ERROR'),
        t('ERROR_RETRIEVING_SHIPPER_ACCESSORIAL_REQUEST_AUTO_DECLINE_DATE'),
        'error',
      );
      console.error(
        `Error retrieving shipper accessorial request auto decline date: ${e.message}`,
      );
      return {};
    }
  };

  getEndOfWaypoints(shipment) {
    if (shipment.current) {
      return moment().toISOString();
    }

    const latestStatus = getLatestStatus(shipment);
    if (latestStatus && latestStatus.at) {
      return latestStatus.at;
    }
    return moment().toISOString();
  }

  getDriverWaypoints = () => {
    const { shipment } = this.state;

    if (shipment && shipment.accepted && this.state.waypointsEnabled) {
      let start;
      if (isIntermodalShipmentType(shipment)) {
        const firstStop = shipment.stops.find((s) => s.sequence === 1);
        if (firstStop && firstStop.timeline.complete) {
          start = firstStop.timeline.complete.at;
        } else {
          start = shipment.deliver_by;
        }
      } else if (
        shipment.timeline &&
        shipment.timeline.accepted &&
        shipment.timeline.accepted.at
      ) {
        start = shipment.timeline.accepted.at;
      } else {
        start = shipment.pickup_after;
      }
      const end = this.getEndOfWaypoints(shipment);
      DriverActionCreators.getDriverWaypoints(
        this.state.shipment.driver._id,
        start,
        end,
      );
    }
  };

  refreshShipment = () => {
    this.getShipment(getIdParam(this.props));
  };

  getShipment(shipment_id = null) {
    let id = '';
    if (shipment_id) {
      id = shipment_id;
    } else {
      const { _id } = this.state.shipment;
      id = _id || this.props.match.params.id;
    }

    ShipmentsActionCreators.getShipmentAuditEvents(id);
    ShipmentsActionCreators.getShipmentV2(id);
    this.getDriverWaypoints();
  }

  getStateFromStores(id) {
    const shipment = ShipmentStore.getShipment(id);

    const stops = _.sortBy(shipment.stops || [], (s) => s.sequence);
    const intermodalShipment = isIntermodalShipmentType(shipment);
    return {
      shipment,
      timezone: getShipmentTimezone(shipment),
      intermodalShipment,
      stops,
      messages: ShipmentStore.getMessages(id),
      audits: ShipmentStore.getShipmentAudit(),
    };
  }

  handleRerateCosts = (shipment, costsToBeRerated) => {
    ShipmentsActionCreators.rerateShipmentCosts(shipment, costsToBeRerated);
  };

  handleGenerateLedger = async (
    ledgerDate,
    selectedCharges,
    sendEdi = false,
    sendEmail = false,
  ) => {
    const { t } = this.props;
    const {
      shipment: {
        order: { _id: orderId },
      },
      ledgerType,
    } = this.state;
    this.setState({
      showGenerateLedgerModal: false,
    });

    try {
      if (ledgerType === RECEIVABLES) {
        await generateOrderInvoice(
          orderId,
          ledgerDate,
          selectedCharges,
          sendEdi,
          sendEmail,
          true,
        );
        showToast(t('INVOICE_GENERATION_SUCCESS'));
        this.refreshShipment();
      } else {
        await generateOrderPayout(orderId, ledgerDate, selectedCharges, true);
        showToast(t('PAYOUT_GENERATION_SUCCESS'));
        this.refreshShipment();
      }
    } catch {
      if (ledgerType === RECEIVABLES) {
        showToast(t('INVOICE_GENERATION_FAILURE'), null, 'error');
      } else {
        showToast(t('PAYOUT_GENERATION_FAILURE'), null, 'error');
      }
    }
  };

  handleShowGenerateLedgerModal = (ledgerType) => () => {
    this.setState({
      ledgerType,
      showGenerateLedgerModal: true,
    });
  };

  handleShowRerateCostModal = () => {
    this.setState({
      showRerateCostModal: true,
    });
  };

  handleHideOverrideBillingStatusModal = () => {
    this.setState({
      showOverrideBillingStatusModal: false,
    });
  };

  handleHideBillingStatusPendingReviewModal = () => {
    this.setState({
      showBillingStatusPendingReviewModal: false,
    });
  };

  handleHideRerateCostModal = () => {
    this.setState({
      showRerateCostModal: false,
    });
  };

  handleHideGenerateLedgerModal = () => {
    this.setState({
      ledgerType: null,
      showGenerateLedgerModal: false,
    });
  };

  updateMissingReferenceNumbers = (missingRefs = []) => {
    if (missingRefs?.length) {
      this.setState({ missingReferenceNumbersList: missingRefs });
    }
  };

  handleAdjustmentsUpdate = () =>
    this.setState({ customAdjustment: null, adjustmentToRemove: null });

  handleEditAdjustment = async (editedAdjustments) => {
    try {
      const { shipment } = this.state;
      const adjustmentIds = editedAdjustments.map((a) => a._id);
      const { ledger } = editedAdjustments[0];
      const adjustments = _.clone(shipment[ledger]);
      const modifiedAdjustments = adjustments.filter(
        (a) => adjustmentIds && adjustmentIds.includes(a._id),
      );

      if (!modifiedAdjustments || !modifiedAdjustments.length) return;

      modifiedAdjustments.forEach((modifiedAdjustment) => {
        const adjustment = editedAdjustments.find(
          (a) => a._id === modifiedAdjustment._id,
        );
        Object.keys(adjustment).forEach((key) => {
          if (key === 'value') {
            modifiedAdjustment[key] = parseFloat(adjustment[key]);
          } else {
            modifiedAdjustment[key] = adjustment[key];
          }
        });
      });

      await ShipmentWebAPIUtils.updateShipmentAdjustments(
        shipment,
        ledger,
        modifiedAdjustments,
      );

      this.refreshShipment();
    } catch (e) {
      console.error(e);
    }
  };

  handleAddComment = async (comment) => {
    const { t } = this.props;
    try {
      const result = await ShipmentWebAPIUtils.addComment(
        this.state.shipment._id,
        comment,
      );
      if (result && result.entity && result.entity.success) {
        showToast(t('COMMENT_UPDATED_SUCCESSFULLY'), '', 'success');
      }
    } catch (e) {
      console.error(e);
      showToast(
        t('COMMENT_UPDATE_FAILED'),
        t('COULDNT_UPDATE_COMMENT', { message: e.message }),
        'error',
      );
    }
  };

  handleAccessorialError = () => {
    const error = ShipmentStore.getAddAccessorialError();
    this.setState({
      accessorialError: error ? { error } : null,
    });
  };

  handleSortStops = (oldIndex, newIndex) => {
    this.setState(
      (prevState) => {
        const stops = arrayMove(prevState.stops, oldIndex, newIndex).map(
          (stop, i) => ({
            ...stop,
            sequence: i + 1,
          }),
        );
        return {
          stops,
        };
      },
      () => {
        const mappedSequences = this.state.stops.reduce((updates, stop) => {
          updates[stop._id] = stop.sequence;
          return updates;
        }, {});
        ShipmentsActionCreators.updateStopSequences(
          this.state.shipment,
          mappedSequences,
        );
      },
    );
  };

  handleShowCustomBulkAccessorialModal = () => {
    this.setState({ showBulkAccessorialModal: true });
  };

  handleHideCustomAccessorialModal = () =>
    this.setState({
      customAdjustment: null,
      showAddOrAdjustDrayageAccessorialModal: false,
    });

  handleAddCustomAdjustment = (customAdjustment) => {
    this.setState({
      customAdjustment,
      showAddOrAdjustDrayageAccessorialModal: true,
    });
  };

  handleShowShipperCostAdjustmentModel = (lineItem) => {
    this.setState({
      selectedLineItemForAdjustment: lineItem,
      showShipperChargeAdjustmentModal: true,
    });
  };

  handleHideShipperCostAdjustmentModel = () => {
    this.setState({
      showShipperChargeAdjustmentModal: false,
    });
  };

  handleShowSendFeesDueEmailModal = () => {
    this.setState({ showSendFeesDueEmailModal: true });
  };

  handleHideSendFeesDueEmailModal = () => {
    this.setState({ showSendFeesDueEmailModal: false });
  };

  handleAddCustomAccessorial = (adjustments) => {
    this.setState({ showAddOrAdjustDrayageAccessorialModal: false });
    adjustments.forEach((data) => {
      const { ledger, adjustment } = data;
      ShipmentsActionCreators.addAdjustment(
        this.state.shipment,
        ledger,
        adjustment,
      );
    });
  };

  handleShipperCostAdjustment = (adjustment) => {
    const transformedLedgerItem = {
      ledger: adjustment.ledger,
      message: 'Shipper Cost Adjustment',
      reason: adjustment.reasonCode,
      notes: adjustment.note,
      equipment: adjustment.derivedEquipment,
      value: adjustment.shipperCost,
      category: 'base_cost',
      type: 'shipper_cost',
      appointment: false,
      adjustedItem: 'base_cost',
    };
    ShipmentsActionCreators.addAdjustment(
      this.state.shipment,
      transformedLedgerItem.ledger,
      transformedLedgerItem,
    );
    this.setState({ showShipperChargeAdjustmentModal: false });
  };

  handleAddBaseCost = async (ledgerType, baseCostLedger) => {
    const { shipment } = this.state;
    if (shipment.shipment_type === 'shorthaul') {
      baseCostLedger.message = 'Base Cost';
    } else if (ledgerType === 'payables') {
      baseCostLedger.message = 'Carrier Cost';
    } else {
      baseCostLedger.message = 'Shipper Cost';
    }

    const response = await ShipmentWebAPIUtils.addBaseCost(
      shipment._id,
      ledgerType,
      baseCostLedger,
    );

    this.refreshShipment();

    if (response.entity.error) {
      console.log(response.entity.error);
      return false;
    }
    return true;
  };

  handleApproveBaseCost = async (ledger) => {
    const { t } = this.props;
    const { shipment } = this.state;

    try {
      await approveCarrierCost(shipment._id, ledger._id);
      showToast(t('APPROVE_CARRIER_COST'), t('CARRIER_COST_APPROVAL_SUCCESS'));

      this.refreshShipment();
    } catch (e) {
      console.error(e);
      showToast(
        t('APPROVE_CARRIER_COST'),
        t('CARRIER_COST_APPROVAL_FAILURE'),
        'error',
      );
    }
  };

  handleRemoveLineItem = async (lineItem, type) => {
    const { t } = this.props;
    const {
      shipment: { _id },
    } = this.state;
    try {
      await removeLineItem(lineItem._id, type, _id);
      this.refreshShipment();
      showToast(t('REMOVE_LINE_ITEM'), t('REMOVE_LINE_ITEM_SUCCESS'));
    } catch (e) {
      console.error(e);
      showToast(
        t('REMOVE_LINE_ITEM'),
        t('REMOVE_LINE_ITEM_FAILED', { error: e.message }),
        'error',
      );
    }
  };

  handleCancelConfirmModal = () =>
    this.setState({
      confirmModalTitle: '',
      confirmModalMessage: '',
      showConfirmModal: false,
    });

  handleCloseCloneShipmentModal = () => {
    this.setState({
      showCloneShipmentModal: false,
    });
  };

  sendDeliveryOrder() {
    return (emails) => {
      ShipmentsActionCreators.sendDeliveryOrder(
        this.state.shipment._id,
        emails,
      );
    };
  }

  sendBolEmail() {
    // Set hardcode this to true until conditional logic is created in future ticket
    return (emails, toSend) => {
      ShipmentsActionCreators.processBol(
        this.state.shipment._id,
        emails,
        toSend,
      );
    };
  }

  handleCloneShipment = (options) => {
    this.handleCloseCloneShipmentModal();
    this.confirmCloneShipment(options);
  };

  handleRemoveAdjustment = ({ _id, ledger }) => {
    const { t } = this.props;
    this.setState({
      confirmModalTitle: t('REMOVE_ADJUSTMENT'),
      confirmModalMessage: t('REMOVE_ADJUSTMENT_CONFIRMATION'),
      showConfirmModal: true,
      showAddOrAdjustDrayageAccessorialModal: false,
      adjustmentToRemove: { _id, ledger },
    });
  };

  closeConfirmModal() {
    this.setState({
      showConfirmModal: false,
    });
  }

  handleRemoveAdjustmentConfirm = () => {
    const {
      shipment,
      adjustmentToRemove: { ledger, _id },
    } = this.state;

    const update = {};

    const accessorialIndex = shipment[ledger].findIndex((a) => a._id === _id);

    if (accessorialIndex === -1) {
      this.closeConfirmModal();
      return;
    }

    shipment[ledger].splice(accessorialIndex, 1);
    update[ledger] = shipment[ledger];

    ShipmentsActionCreators.updateAdjustments(this.state.shipment, update);
    this.closeConfirmModal();
  };

  handleWaypointsSelect() {
    this.setState(
      (prevState) => ({ waypointsEnabled: !prevState.waypointsEnabled }),
      () => {
        this.getDriverWaypoints();
      },
    );
  }

  handleConfirmStateTransitionModal = () => {
    ShipmentsActionCreators.transitionTo(
      this.state.shipment,
      this.state.nextState.status,
      this.state.nextState.meta,
    );
    this.handleHideConfirmStateTransitionModal();
  };

  handleUpdateShipmentEquipmentType = (shipment, values) => {
    ShipmentsActionCreators.updateEquipmentType(shipment, values);
  };

  addIncentive() {
    return (adjustment) => {
      ShipmentsActionCreators.addAdjustment(
        this.state.shipment,
        'payables',
        adjustment,
      );
    };
  }

  confirmCloneShipment(options) {
    ShipmentsActionCreators.cloneShipment(this.state.shipment, options);
  }
  fetchShipperInvoiceSettings = async (shipperId = '') => {
    if (shipperId) {
      try {
        const [invoiceSettingsResult, pendingAccessorialsResult] =
          await Promise.all([
            getUserInvoiceSettings(shipperId),
            getPendingAccessorialInclusion(shipperId),
          ]);
        const invoiceSettings =
          invoiceSettingsResult?.data?.getInvoiceSetting?.invoice_setting;
        const pendingAccessorialInclusion =
          !!pendingAccessorialsResult.data?.getBillReadyStatusCalculation
            ?.include_pending_accessorials_in_calculation;
        this.setState({
          shipperInvoiceSettings: invoiceSettings,
          pendingAccessorialInclusion,
        });
      } catch (e) {
        this.setState({
          shipperInvoiceSettings: null,
          pendingAccessorialInclusion: false,
        });
        console.error(e);
      }
    }
  };

  async getStateTransitions() {
    const { shipment } = this.state;

    if (!_.isEmpty(shipment)) {
      const result = await FetchWebAPIUtils.getForwardRegress({ shipment });
      const { progress, regress } = result;
      this.setState({ progress, regress });
    }
  }

  _onAuditsChange = () => {
    const id = getIdParam(this.props);
    this.setState((prevState) => {
      return Object.assign({}, prevState, this.getStateFromStores(id));
    });
  };

  _onChange = () => {
    const id = getIdParam(this.props);
    this.setState(
      (prevState) => {
        return Object.assign({}, prevState, this.getStateFromStores(id));
      },
      async () => {
        await Promise.all([
          this.fetchShipperInvoiceSettings(this.state.shipment?.shipper?._id),
          this.getStateTransitions(),
        ]);
        this.state.documentsRefetch?.();
      },
    );
  };

  setDocumentsRefetchRef = (documentsRefetch) => {
    this.setState({
      documentsRefetch,
    });
  };

  _onDriverWaypoints = () => {
    const waypoints = DriverStore.getDriverWaypoints();
    if (waypoints && waypoints.coords && waypoints.coords.length > 0) {
      this.setState({ waypoints: waypoints.coords });
    }
  };

  renderMessages() {
    if (!this.state.messages) return null;

    return this.state.messages
      .filter((message) => {
        return !(
          message.includes('base payable rate') &&
          isIntermodalShipmentType(this.state.shipment)
        );
      })
      .map((message, i) => (
        <Alert
          key="message"
          onDismiss={clearMessage(this.state.shipment._id, i)}
        >
          <div
            data-testid={`div-035f2609-${i}`}
            dangerouslySetInnerHTML={{ __html: marked(message) }}
          />
        </Alert>
      ));
  }

  renderPortIntegration(shipment) {
    return <PortIntegration data={shipment} isShipment />;
  }

  renderAccountingPanel(shipment, accessorialRequests = []) {
    return (
      <Accounting
        shipment={shipment}
        accessorialRequests={accessorialRequests}
        refreshShipment={this.refreshShipment}
        onAddCustomAdjustment={this.handleAddCustomAdjustment}
        onAddShipperCostAdjustment={(lineItem) =>
          this.handleShowShipperCostAdjustmentModel(lineItem)
        }
        onAddBaseCost={this.handleAddBaseCost}
        onApproveBaseCost={this.handleApproveBaseCost}
        onRemoveLineItem={this.handleRemoveLineItem}
      />
    );
  }

  setShouldDisableAllAccessorialActions = (
    selectedAccessorialRequests = [],
  ) => {
    const shouldDisableAllAccessorialActions =
      !selectedAccessorialRequests.length;
    this.setState({ shouldDisableAllAccessorialActions });
  };

  handleAccessorialActionSelect = (accessorialAction) => {
    if (accessorialAction === 'edit_all')
      return this.setState({
        showBulkAccessorialModal: true,
        bulkAccessorialModalEditMode: true,
      });
    this.setState({ accessorialAction });
  };

  handleAccessorialRequestSelect = (selectedAccessorialRequests) =>
    this.setState({ selectedAccessorialRequests }, () =>
      this.setShouldDisableAllAccessorialActions(selectedAccessorialRequests),
    );

  handleAccessorialOnSubmit = async (payload) => {
    try {
      const { t } = this.props;
      if (this.state.accessorialAction === 'notify_all') {
        AccessorialRequestActionCreators.updateAccessorialRequest(payload);
        return this.setState({
          accessorialAction: '',
          selectedAccessorialRequests: [],
        });
      }
      const {
        entity: { result },
      } = await resolveAccessorialsStatus(payload);
      const errors = result.errors || [];
      const successes = result.successes || [];

      if (errors[0]?.job) {
        this.refreshShipment();
        const approveAccessorialsWarning =
          successes.length > 0
            ? t('ACCESSORIAL_UPDATE_CARRIER_SOME_EMAIL_NOT_SENT', {
                error: humanize(errors[0].error),
              })
            : t('ACCESSORIAL_UPDATE_CARRIER_ALL_EMAIL_NOT_SENT', {
                error: humanize(errors[0].error),
              });
        showToast(
          t('APPROVE_ACCESSORIALS'),
          approveAccessorialsWarning,
          'warning',
        );
      } else if (successes[0]?.job) {
        // this.refreshShipment();

        // this.setState({ shipment: successes[0].job });
        if (this.state.accessorialAction === 'approve_all') {
          showToast(
            t('APPROVE_ACCESSORIALS'),
            t('APPROVE_ACCESSORIALS_SUCCESS'),
            'success',
          );
        } else {
          showToast(
            t('DECLINE_ACCESSORIALS'),
            t('DECLINE_ACCESSORIALS_SUCCESS'),
            'success',
          );
        }
      } else if (errors?.length) {
        errors.forEach(({ error }) => {
          const title =
            this.state.accessorialAction === 'approve_all'
              ? 'APPROVE_ACCESSORIALS'
              : 'DECLINE_ACCESSORIALS';
          showToast(t(title), error, 'error');
        });
      }
      return this.setState(
        {
          accessorialAction: '',
          selectedAccessorialRequests: [],
        },
        () => this.getAccessorials(),
      );
    } catch (e) {
      showToast(e.message, null, 'error');
    }
  };

  handleAccessorialRemove = (accessorialId) => {
    this.setState((prevState) => {
      return {
        selectedAccessorialRequests:
          prevState.selectedAccessorialRequests.filter(
            (acc) => acc._id !== accessorialId,
          ),
      };
    });
  };

  userCanApproveAccessorials = () => {
    const { selectedAccessorialRequests } = this.state;
    const user = SessionStore.getUser();
    const autoAppliedNeedsReviewAccessorialPresent =
      checkIfAccessorialsNeedsReview(selectedAccessorialRequests);
    return (
      userCanApproveAccessorialsHelper(user, selectedAccessorialRequests) &&
      !autoAppliedNeedsReviewAccessorialPresent
    );
  };

  isMissingDocs = (accessorials) => {
    return accessorials.some(
      (acc) => acc.hasOwnProperty('missing_docs') && !!acc?.missing_docs,
    );
  };

  renderAccessorialRequestsPanelHeader = () => {
    const {
      shipment,
      shouldDisableAllAccessorialActions,
      selectedAccessorialRequests,
    } = this.state;
    const { t } = this.props;
    const autoAppliedNeedsReviewAccessorialPresent =
      checkIfAccessorialsNeedsReview(selectedAccessorialRequests);
    const missingEquipment = checkIfEquipmentIsMissing(
      selectedAccessorialRequests,
    );
    return (
      <div
        data-testid="div-5d91e3af"
        id="accessorial-requests-actions-dropdown"
        className=""
      >
        <div
          data-testid="div-13180b0e"
          className="flex justify-between my-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <ShadcnDropdownMenu>
            <ShadcnDropdownMenuTrigger asChild>
              <ShadcnButton
                variant="outline"
                disabled={shouldDisableAllAccessorialActions}
              >
                {t('ACTIONS')}
                <ShadcnChevronDown className="ml-2 h-4 w-4" />
              </ShadcnButton>
            </ShadcnDropdownMenuTrigger>
            <ShadcnDropdownMenuContent align="end">
              <ShadcnDropdownMenuItem
                disabled={!SessionStore.isAdmin()}
                onSelect={() => this.handleAccessorialActionSelect('edit_all')}
              >
                {t('EDIT_ACCESSORIAL')}
              </ShadcnDropdownMenuItem>
              <ShadcnDropdownMenuItem
                disabled={
                  !this.userCanApproveAccessorials() || missingEquipment
                }
                onSelect={() =>
                  this.handleAccessorialActionSelect('approve_all')
                }
              >
                {t('APPROVE')}
              </ShadcnDropdownMenuItem>
              <ShadcnDropdownMenuItem
                onSelect={() =>
                  this.handleAccessorialActionSelect('decline_all')
                }
              >
                {t('DECLINE')}
              </ShadcnDropdownMenuItem>
              <ShadcnDropdownMenuItem
                disabled={
                  autoAppliedNeedsReviewAccessorialPresent || missingEquipment
                }
                onSelect={() =>
                  this.handleAccessorialActionSelect('notify_all')
                }
              >
                {t('NOTIFY_SHIPPER')}
              </ShadcnDropdownMenuItem>
            </ShadcnDropdownMenuContent>
          </ShadcnDropdownMenu>
          {this.state.shipment && (
            <div data-testid="div-aaf8ea45" className="ml-4">
              <AddButton
                dataTestId="AddButton-a75e1cff"
                onClick={this.handleShowCustomBulkAccessorialModal}
                disabled={isShipmentCanceled(shipment)}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  handleShowAccessorialRequestPane = (accessorial) => {
    this.setState({
      selectedAccessorialRequest: accessorial._id,
      showAccessorialRequestPane: true,
    });
  };

  renderAccessorialRequests(shipment) {
    return (
      <AccessorialRequests
        dontRefresh={this.props.dontRefresh}
        shipment={shipment}
        accessorials={this.state.accessorials}
        accessorialRequestIds={this.state.accessorialRequestIds}
        selectedAccessorials={this.state.selectedAccessorialRequests.map(
          (acc) => acc._id,
        )}
        onAccessorialSelect={this.handleAccessorialRequestSelect}
        handleRequestSelect={this.handleShowAccessorialRequestPane}
      />
    );
  }

  hideAccessorialRequestPane = () => {
    this.setState({ showAccessorialRequestPane: false });
  };

  getDetailComponent() {
    const { selectedAccessorialRequest, shipment } = this.state;
    const shipmentId = shipment?._id;
    return (
      <AccessorialRequestPane
        accessorial={selectedAccessorialRequest}
        shipment={shipmentId}
        showAccessorialRequestPane
        onSave={() => {
          if (shipmentId) {
            ShipmentsActionCreators.getShipment(shipmentId, true);
          }
        }}
      />
    );
  }

  renderPane() {
    if (!this.state.showAccessorialRequestPane) {
      return null;
    }
    const { t } = this.props;
    return (
      <div data-testid="div-5c46df79">
        <div data-testid="div-73ca0221" id="pane-container" />
        <CargomaticPane
          dataTestId="CargomaticPane-4c364bda"
          show={this.state.showAccessorialRequestPane}
          title={t('ACCESSORIAL_REQUESTS')}
          onHide={() => this.hideAccessorialRequestPane()}
          renderBody={() => this.getDetailComponent()}
          location="right"
        />
      </div>
    );
  }

  isMissingReferenceNumbers = () => {
    const { shipment } = this.state;
    if (shipment && INTERMODAL_TYPES.includes(shipment.shipment_type)) {
      return shipment.missing_reference_numbers;
    }
    return false;
  };

  handleStateTransition = (shipment, status, meta) => {
    this.setState({
      showConfirmStateTransitionModal: true,
      nextState: { status, meta },
    });
  };

  getStateTransitionMessage(status) {
    const { t } = this.props;
    if (
      ShipmentStateDefinition[status] &&
      ShipmentStateDefinition[status].description
    ) {
      return (
        <div data-testid="div-be22175b">
          <div data-testid="div-fecf82ec">
            <span data-testid="span-c1254e25">
              {t(ShipmentStateDefinition[status].description)}
            </span>
          </div>
          <div data-testid="div-807637d5" className="mt-4">
            <span data-testid="span-20e1a0b7">{t('CONFIRM_IF_SURE')}</span>
          </div>
        </div>
      );
    }
    return t('CHANGE_JOB_STATUS_CONFIRMATION', { status });
  }

  _getDeliveryOrderRecipients = () => {
    const { carrier } = this.state.shipment;
    return getDeliveryOrderRecipients(carrier);
  };
  removeCarrier = async () => {
    const {
      shipment: { _id },
    } = this.state;

    const result = await ShipmentWebAPIUtils.removeCarrier(_id);
    if (result) {
      this.setState({ /*shipment: result,*/ showConfirmRemoveModal: false });
      this.refreshShipment();
    }
  };

  generateCarrier204 = (event) =>
    ShipmentWebAPIUtils.generateCarrier204(this.state.shipment._id, event);

  render() {
    const shipment = this.state.shipment;
    const { t, localeData } = this.props;
    if (_.isEmpty(shipment))
      return <div data-testid="div-b7ef1db3">{t('LOADING')}</div>;

    const deliveryOrderRecipient = this._getDeliveryOrderRecipients();

    shipment.exceptions = _.without(
      shipment.exceptions,
      _.findWhere(shipment.exceptions, {
        type: 'quality',
      }),
    ); // right now we just delete quality exceptions from this page

    document.title = shipment.shipment_id;
    const isDrayage = isIntermodalShipmentType(shipment);

    const {
      shipment: { carrier, shipper },
      accessorials: accessorialRequests,
      status,
      missingReferenceNumbersList,
    } = this.state;
    return (
      <div data-testid="div-8efdc855">
        {this.state.showGenerateLedgerModal && (
          <GenerateLedgerModal
            show={this.state.showGenerateLedgerModal}
            equipment={getEquipmentList(this.state.shipment)}
            shipper={shipper}
            carrier={carrier}
            shipments={[this.state.shipment]}
            orderId={shipment?.order?._id || null}
            ledgerType={this.state.ledgerType}
            onGenerateLedger={this.handleGenerateLedger}
            onClose={this.handleHideGenerateLedgerModal}
            useShipmentAddress
            shipperInvoiceSettings={this.state.shipperInvoiceSettings}
          />
        )}
        {this.state.showRerateCostModal && (
          <RerateCostModal
            show={this.state.showRerateCostModal}
            shipment={this.state.shipment}
            onRerateCosts={this.handleRerateCosts}
            onClose={this.handleHideRerateCostModal}
          />
        )}
        {this.renderMessages()}
        <ShipmentHolds shipment={this.state.shipment} />
        <div data-testid="div-a76ce9a7" className="pt-4">
          <StatusBar
            progress={this.state.progress}
            regress={this.state.regress}
            onClose={() => this.props.onClose()}
            showCloseButton={this.props.showCloseButton}
            shipment={{ ...shipment, missingReferenceNumbersList }}
            onCreateHold={() => {
              this.setState({ showHoldModal: true });
            }}
            onRemoveCarrier={() => {
              this.setState({ showConfirmRemoveModal: true });
            }}
            onCloneShipment={() => {
              this.setState({ showCloneShipmentModal: true });
            }}
            onSendBOLMailModal={() => {
              this.setState({ showSendBOLEmailModal: true });
            }}
            onSendRATEEmailModal={() => {
              this.setState({ showSendRATEEmailModal: true });
            }}
            onSendDOEMailModal={() => {
              this.setState({ showSendDOEmailModal: true });
            }}
            onAssignDriver={() => {
              this.setState({ showAssignDriverModal: true });
            }}
            onShowCancelShipmentModal={() => {
              this.setState({ showCancelShipmentModal: true });
            }}
            onShipmentTransition={this.handleStateTransition}
            onModifyAccessorials={() => {
              if (isIntermodalShipmentType(shipment)) {
                this.setState({ showAddOrAdjustDrayageAccessorialModal: true });
              } else {
                this.setState({ showAddAccessorialModal: true });
              }
            }}
            onBulkAddAccessorial={() => {
              this.setState({ showBulkAccessorialModal: true });
            }}
            onReOpenShipment={() => {
              this.setState({ showShipmentReOpenModal: true });
            }}
            onCloseShipment={ShipmentsActionCreators.closeShipment}
            onSaveToggleOnHold={ShipmentsActionCreators.updateOnHold}
            onGenerateCarrier204={this.generateCarrier204}
            onSaveToggleExposed={ShipmentsActionCreators.updateExposed}
            onOverrideBillingStatus={() =>
              this.setState({ showOverrideBillingStatusModal: true })
            }
            onMarkBillingStatusPendingReview={() =>
              this.setState({ showBillingStatusPendingReviewModal: true })
            }
          />
          <ShipmentRoute
            shipment={shipment}
            stops={this.state.stops}
            waypoints={this.state.waypoints}
            disableStopActions={isLegManagementEnabled(shipment?.order)}
            onWaypointsSelect={this.handleWaypointsSelect.bind(this)}
            showWaypoints={this.state.waypointsEnabled}
            onStopModified={ShipmentsActionCreators.updateShipmentStop}
            onStopLoadsModified={
              ShipmentsActionCreators.updateShipmentStopLoads
            }
            onStopWindowModified={
              ShipmentsActionCreators.updateShipmentStopWindow
            }
            onSaveLocationIntentChanges={
              ShipmentsActionCreators.updateShipmentStopLocation
            }
            onSaveReferenceNumbers={
              ShipmentsActionCreators.updateShipmentStopReferenceNumbers
            }
            onUploadStopDocument={ShipmentsActionCreators.uploadStopDocument}
            onDeleteStopDocument={ShipmentsActionCreators.deleteStopDocument}
            onCancelStop={ShipmentsActionCreators.cancelStop}
            onCopyStop={ShipmentsActionCreators.copyStop}
            onCompleteStop={ShipmentsActionCreators.completeStop}
            onStopTransition={ShipmentsActionCreators.transitionStop}
            onSortStops={this.handleSortStops}
            onAddComment={this.handleAddComment}
          />
        </div>
        <div data-testid="div-1af8af11" className="pt-4">
          <CargomaticCollapsibleCard
            id="shipment-events"
            header={() => (
              <div className="flex items-center gap-1.5">
                <span>{t('SHIPMENT_EVENTS')}</span>
                <TooltipProvider>
                  <ShadcnTooltip>
                    <TooltipTrigger asChild>
                      <span className="inline-flex">
                        <Info className="w-4 h-4 text-muted-foreground" />
                      </span>
                    </TooltipTrigger>
                    <TooltipContent>
                      {t('SHIPMENT_EVENTS_TOOLTIP')}
                    </TooltipContent>
                  </ShadcnTooltip>
                </TooltipProvider>
              </div>
            )}
          >
            {shipment && this.state.audits && (
              <Events
                shipment={shipment}
                audits={this.state.audits}
                stops={this.state.stops}
              />
            )}
          </CargomaticCollapsibleCard>
        </div>
        <div data-testid="div-4e356072" className="pt-4">
          <CargomaticCollapsibleCard
            id="marketplace-status"
            header={() => (
              <div className="flex items-center gap-1.5">
                <span>{t('MARKETPLACE_STATUS')}</span>
                {!isNil(shipment.last_distribution_radius) && (
                  <TooltipProvider>
                    <ShadcnTooltip>
                      <TooltipTrigger asChild>
                        <span className="inline-flex">
                          <Info className="w-4 h-4 text-muted-foreground" />
                        </span>
                      </TooltipTrigger>
                      <TooltipContent>
                        {t('MARKETPLACE_STATUS_TOOLTIP', {
                          last_distribution_radius: unitConverter(
                            shipment.last_distribution_radius,
                          )
                            .from('mi')
                            .to(localeData.distance_units)
                            .toFixed(2),
                          distanceUnit: localeData.distance_units,
                        })}
                      </TooltipContent>
                    </ShadcnTooltip>
                  </TooltipProvider>
                )}
              </div>
            )}
          >
            <MarketplaceStatus shipment={shipment} isDrayage={isDrayage} />
          </CargomaticCollapsibleCard>
        </div>
        <div
          data-testid="div-57bb9168"
          className="space-y-4 lg:space-y-0 lg:grid lg:grid-cols-12 lg:gap-8"
        >
          <div data-testid="div-71894078" className="lg:col-span-12">
            <div data-testid="div-f9326993" className="pt-6">
              <CargomaticCollapsibleCard
                id="shipment-accounting"
                header={() => (
                  <div className="flex flex-wrap items-center gap-3">
                    <span>{t('ACCOUNTING')}</span>
                    {featureEnabled(CONFIGURED_FEATURES.SSR) &&
                      this.isMissingReferenceNumbers() && (
                        <Badge dataTestId="Badge-6825507c" color="red">
                          {t('MISSING_REFERENCE_NUMBERS')}
                        </Badge>
                      )}
                    {isIntermodalShipmentType(shipment) &&
                      !isLegManagementEnabled(shipment?.order) && (
                        <>
                          <Badge
                            dataTestId="Badge-3a768ca5"
                            color="blue"
                          >{`${t('INVOICE_GROUPING')}: ${t(this.state?.shipperInvoiceSettings?.invoice_grouping || 'UNLIMITED')}`}</Badge>
                          <Badge
                            dataTestId="Badge-17425368"
                            color="purple"
                          >{`${t('PENDING_ACCESSORIAL_EVALUATION')}: ${this.state.pendingAccessorialInclusion ? t('YES') : t('NO')}`}</Badge>
                        </>
                      )}
                    {this.state.intermodalShipment &&
                      !this.state.shipment.canceled && (
                        <div
                          data-testid="div-b498874f"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <DropdownMenu
                            dataTestId="DropdownMenu-6967c335"
                            title={t('ACTIONS')}
                          >
                            {!isLegManagementEnabled(
                              this.state.shipment?.order,
                            ) && (
                              <Menu.Item
                                data-testid="MenuItem-f13f218e"
                                key="create_invoice"
                              >
                                <DropdownItem
                                  dataTestId="DropdownItem-466ab658"
                                  disabled={
                                    !this.state.shipment.needs_invoice ||
                                    (featureEnabled(CONFIGURED_FEATURES.SSR) &&
                                      this.isMissingReferenceNumbers())
                                  }
                                  onClick={this.handleShowGenerateLedgerModal(
                                    'receivables',
                                  )}
                                >
                                  {t('CREATE_INVOICE')}
                                </DropdownItem>
                              </Menu.Item>
                            )}
                            <Menu.Item
                              data-testid="MenuItem-32fcde00"
                              key="create_payout"
                            >
                              <DropdownItem
                                dataTestId="DropdownItem-a7c3db6e"
                                disabled={!this.state.shipment.needs_payout}
                                onClick={this.handleShowGenerateLedgerModal(
                                  'payables',
                                )}
                              >
                                {t('CREATE_PAYOUT')}
                              </DropdownItem>
                            </Menu.Item>
                            <Menu.Item
                              data-testid="MenuItem-75857402"
                              key="rerate_costs"
                            >
                              <DropdownItem
                                dataTestId="DropdownItem-3ebb626d"
                                onClick={this.handleShowRerateCostModal}
                              >
                                {t('RERATE_COSTS')}
                              </DropdownItem>
                            </Menu.Item>
                            <Menu.Item
                              data-testid="MenuItem-10cb86e4"
                              key="send_fees_due_payment"
                            >
                              <DropdownItem
                                dataTestId="DropdownItem-72ecc59f"
                                onClick={this.handleShowSendFeesDueEmailModal}
                              >
                                {t('SEND_FEES_PAST_DUE_EMAIL')}
                              </DropdownItem>
                            </Menu.Item>
                          </DropdownMenu>
                        </div>
                      )}
                  </div>
                )}
              >
                {isLegManagementEnabled(shipment?.order) && (
                  <OrderRtbBanner order={shipment?.order} />
                )}
                {this.renderAccountingPanel(shipment, accessorialRequests)}
              </CargomaticCollapsibleCard>
            </div>
          </div>

          {isIntermodalShipmentType(shipment) && (
            <div data-testid="div-e188759f" className="lg:col-span-12">
              <MeteringTable shipment={shipment} />
            </div>
          )}

          {isIntermodalShipmentType(shipment) && (
            <div data-testid="div-4779fb7a" className="lg:col-span-12">
              <CargomaticCollapsibleCard
                id="accessorial-requests"
                dataTestId="CargomaticCard-d6ad0c38"
                header={() => (
                  <>
                    <div
                      data-testid="div-a6f145d5"
                      className="flex items-center justify-between"
                    >
                      <span>{t('ACCESSORIAL_REQUESTS')}</span>
                      {this.renderAccessorialRequestsPanelHeader()}
                    </div>
                    <div className="flex flex-wrap items-center gap-2 mt-2">
                      <Badge color="blue">{`${t('INVOICE_GROUPING')}: ${t(this.state?.shipperInvoiceSettings?.invoice_grouping || 'UNLIMITED')}`}</Badge>
                      <Badge color="purple">{`${t('PENDING_ACCESSORIAL_EVALUATION')}: ${this.state.pendingAccessorialInclusion ? t('YES') : t('NO')}`}</Badge>
                    </div>
                  </>
                )}
              >
                {this.renderAccessorialRequests(shipment)}
                {this.renderPane()}
              </CargomaticCollapsibleCard>
            </div>
          )}

          {isIntermodalShipmentType(shipment) &&
            featureEnabled(CONFIGURED_FEATURES.MARKET_EXCEPTIONS) && (
              <div data-testid="div-4779ub7a" className="lg:col-span-12">
                <ShipmentBridges shipmentId={shipment._id} />
              </div>
            )}

          <div data-testid="div-89cf407d" className="lg:col-span-6">
            {isDrayage && (
              <div data-testid="div-e1a932d7" className="pt-6">
                <HazmatDetails order={shipment.order} isEditable={false} />
              </div>
            )}
            {isDrayage && (
              <div data-testid="div-e1a932d6" className="pt-6">
                {this.renderPortIntegration(shipment)}
              </div>
            )}
            <div data-testid="div-2f521ac9" className="pt-6">
              <ShipmentDetails
                shipment={shipment}
                updateMissingReferenceNumbers={
                  this.updateMissingReferenceNumbers
                }
                status={status}
                audits={this.state.audits || null}
                onReferenceNumbersChange={
                  ShipmentsActionCreators.updateReferenceNumbers
                }
                onNotesUpdate={ShipmentsActionCreators.updateShipperNotes}
                onStackPositionUpdate={
                  ShipmentsActionCreators.updateStackPosition
                }
                onAdminNotesUpdate={ShipmentsActionCreators.updateAdminNotes}
                onTagsUpdate={ShipmentsActionCreators.updateTags}
                onUpdateEstimatedArrivalChange={(value) => {
                  ShipmentsActionCreators.updateEstimatedArrival(
                    shipment,
                    value,
                  );
                }}
                onUpdateArrivalDateChange={(value) => {
                  ShipmentsActionCreators.updateArrivalDate(shipment, value);
                }}
                onUpdateDischargeDateChange={(value) => {
                  ShipmentsActionCreators.updateDischargeDate(shipment, value);
                }}
                onUpdateCustomLfdChange={(value) => {
                  ShipmentsActionCreators.updateCustomLfd(shipment, value);
                }}
                onUpdateAvailableDateChange={(value) => {
                  ShipmentsActionCreators.updateAvailableDate(shipment, value);
                }}
                onUpdateLastFreeDateChange={(value) => {
                  ShipmentsActionCreators.updateLastFreeDate(shipment, value);
                }}
                onUpdateYardLastFreeDateChange={(value) => {
                  ShipmentsActionCreators.updateYardLastFreeDate(
                    shipment,
                    value,
                  );
                }}
                onUpdateYardAvailableDateChange={(value) => {
                  ShipmentsActionCreators.updateYardAvailableDate(
                    shipment,
                    value,
                  );
                }}
                onUpdateEmptyReturnedDateChange={(value) => {
                  ShipmentsActionCreators.updateEmptyReturnedDate(
                    shipment,
                    value,
                  );
                }}
                onUpdateLastCutDateChange={(value) => {
                  ShipmentsActionCreators.updateLastCutDate(shipment, value);
                }}
                onUpdateDocumentCutoffDateChange={(value) => {
                  ShipmentsActionCreators.updateDocumentCutoffDate(
                    shipment,
                    value,
                  );
                }}
                onUpdateEarliestReturnDateChange={(value) => {
                  ShipmentsActionCreators.updateEarliestReturnDate(
                    shipment,
                    value,
                  );
                }}
                onUpdateEarliestEmptyDateChange={(value) => {
                  ShipmentsActionCreators.updateEarliestEmptyDate(
                    shipment,
                    value,
                  );
                }}
                onUpdateEmptyReadyForPickupDateChange={(value) => {
                  ShipmentsActionCreators.updateEmptyReadyForPickupDate(
                    shipment,
                    value,
                  );
                }}
                onUpdatePerDiemDateChange={(value) => {
                  ShipmentsActionCreators.updatePerDiemDate(shipment, value);
                }}
                onUpdateOutgatedDateChange={(value) => {
                  ShipmentsActionCreators.updateOutgatedDate(shipment, value);
                }}
                onUpdateCfsGateInChange={(value) => {
                  ShipmentsActionCreators.updateCfsGateIn(shipment, value);
                }}
                onUpdateCfsGateOutChange={(value) => {
                  ShipmentsActionCreators.updateCfsGateOut(shipment, value);
                }}
                onShipmentTypeChange={(value) => {
                  ShipmentsActionCreators.updateShipmentType(shipment, value);
                }}
                onCustomerServiceTypeChange={(item) => {
                  // The dropdown's onSave passes the selected item object; its
                  // value is one of the enum strings or null (clear).
                  ShipmentsActionCreators.updateCustomerServiceType(
                    shipment,
                    item && typeof item === 'object' ? item.value : item,
                  );
                }}
                onEquipmentTypeChange={(value) => {
                  this.handleUpdateShipmentEquipmentType(shipment, value);
                }}
                onExceptionExemptChange={(value) => {
                  ShipmentsActionCreators.updateExceptionExemptFlag(
                    shipment,
                    value,
                  );
                }}
                onPODValidChange={(podType) => {
                  ShipmentsActionCreators.updatePODValid(
                    shipment,
                    podType?.value ? podType.value : podType,
                  );
                }}
                onAddComment={this.handleAddComment}
                onUpdateRailEvent={(event, value) => {
                  ShipmentsActionCreators.updateRailEvent(
                    shipment,
                    event,
                    value,
                  );
                }}
                onUpdateImportantDates={(event, value) => {
                  ShipmentsActionCreators.updateImportantDates(
                    shipment,
                    event,
                    value,
                  );
                }}
              />
            </div>
          </div>
          <div data-testid="div-1f098c3f" className="lg:col-span-6">
            <div data-testid="div-ec3bafbf" className="pt-6">
              <Card id="shipment-documents">
                <CardContent className="pt-6">
                  <div className="flex items-center gap-1.5 mb-4">
                    <span className="font-semibold">{t('DOCUMENTS')}</span>
                    <TooltipProvider>
                      <ShadcnTooltip>
                        <TooltipTrigger asChild>
                          <span className="inline-flex">
                            <Info className="w-4 h-4 text-muted-foreground" />
                          </span>
                        </TooltipTrigger>
                        <TooltipContent>
                          {t('DOCUMENT_LIST_SUPPORTED_FORMATS')}
                        </TooltipContent>
                      </ShadcnTooltip>
                    </TooltipProvider>
                    {isDrayageOrRailShipment(shipment) && (
                      <ShipmentInvoiceDocumentPreferences
                        preferences={shipper.invoice_document_preferences}
                      />
                    )}
                  </div>
                  <Documents
                    onDelete={(document) => {
                      console.log('Deleted Document: ', document);
                    }}
                    onUpload={(shipment, type, documents) => {
                      console.log('Uploaded Documents: ', documents);
                    }}
                    shipment={shipment}
                    isOrder={false}
                    refetchRef={(documentsRefetch) =>
                      this.setDocumentsRefetchRef(documentsRefetch)
                    }
                  />
                </CardContent>
              </Card>
            </div>
            <div data-testid="div-743f3f33" className="pt-6">
              <CargomaticCollapsibleCard
                id="shipment-discussion"
                dataTestId="CargomaticCard-37912872"
                header={() => <span>{t('DISCUSSION')}</span>}
              >
                <CommentList
                  paginate
                  itemsPerPage={10}
                  id={shipment._id}
                  comments={shipment.comments}
                  onCommentAdd={this.handleAddComment}
                />
              </CargomaticCollapsibleCard>
            </div>
            {/* <div className="pt-6">
              <CargomaticCard
                header={() => <h3 className="my-0">Audit History</h3>}
              >
                <AuditHistory audits={this.state.audits} paginate />
              </CargomaticCard>
            </div> */}
          </div>
        </div>
        <CloneShipmentModal
          onClone={this.handleCloneShipment}
          onHide={this.handleCloseCloneShipmentModal}
          show={this.state.showCloneShipmentModal}
        />
        <AddAccessorialModal
          shipment={shipment}
          show={this.state.showAddAccessorialModal}
          addAccessorial={ShipmentsActionCreators.addAccessorial}
          removeAccessorial={ShipmentsActionCreators.removeAccessorial}
          accessorialError={this.state.accessorialError}
          requireApproval={shipment.shipper.requires_accessorial_approval}
          onHide={() => this.setState({ showAddAccessorialModal: false })}
        />
        <ShipperCostAdjustmentModel
          shipment={shipment}
          selectedLineItem={this.state.selectedLineItemForAdjustment}
          show={this.state.showShipperChargeAdjustmentModal}
          equipments={getEquipmentList(shipment)}
          onSave={this.handleShipperCostAdjustment}
          onHide={this.handleHideShipperCostAdjustmentModel}
        />
        {this.state.showAddOrAdjustDrayageAccessorialModal && (
          <AddOrAdjustDrayageAccessorialModal
            shipment={shipment}
            show={this.state.showAddOrAdjustDrayageAccessorialModal}
            customAdjustment={this.state.customAdjustment}
            equipment={getEquipmentList(shipment)}
            onSave={this.handleAddCustomAccessorial}
            onHide={this.handleHideCustomAccessorialModal}
            onRemoveAdjustment={this.handleRemoveAdjustment}
            onEditAdjustment={this.handleEditAdjustment}
          />
        )}
        <AssignDriverModal
          shipments={[]}
          shipment={shipment}
          show={this.state.showAssignDriverModal}
          onAssignDriver={ShipmentsActionCreators.assignDriver}
          onAssignBrokerCarrier={(shipment, driver) =>
            this.setState({
              showConfirmAssignCarrierModal: true,
              showAssignDriverModal: false,
              brokerCarrierDriver: driver,
            })
          }
          onHide={() => this.setState({ showAssignDriverModal: false })}
        />
        <ConfirmAssignCarrierModal
          isOpen={this.state.showConfirmAssignCarrierModal}
          brokerCarrierDriver={this.state.brokerCarrierDriver}
          shipment={{ _id: shipment._id }}
          onConfirm={ShipmentsActionCreators.assignDriver}
          onClose={() =>
            this.setState({ showConfirmAssignCarrierModal: false })
          }
        />
        <AddIncentiveModal
          show={this.state.showIncentiveModal}
          addIncentive={this.addIncentive()}
          onHide={() => this.setState({ showIncentiveModal: false })}
        />
        <CancelShipmentModal
          shipment={shipment}
          onCancelShipment={ShipmentsActionCreators.cancelShipment}
          show={this.state.showCancelShipmentModal}
          onHide={() => this.setState({ showCancelShipmentModal: false })}
        />
        <SendBolEmailModal
          shipment={shipment}
          show={this.state.showSendBOLEmailModal}
          onSend={this.sendBolEmail()}
          onHide={() => this.setState({ showSendBOLEmailModal: false })}
        />
        <SendRATEEmailModal
          shipment={shipment}
          show={this.state.showSendRATEEmailModal}
          onHide={() => this.setState({ showSendRATEEmailModal: false })}
        />
        <SendDOEmailModal
          show={this.state.showSendDOEmailModal}
          onSend={this.sendDeliveryOrder()}
          onHide={() => this.setState({ showSendDOEmailModal: false })}
          defaultRecipient={deliveryOrderRecipient}
        />
        <ShipmentReopenModal
          show={this.state.showShipmentReOpenModal}
          transition={ShipmentsActionCreators.transitionTo}
          shipment={shipment}
          onHide={() => this.setState({ showShipmentReOpenModal: false })}
        />
        {this.state.showBulkAccessorialModal && (
          <BulkAddAccessorialsModal
            show={this.state.showBulkAccessorialModal}
            orderId={shipment.order._id || null}
            shipmentIds={[shipment].map((s) => s._id)}
            onSave={this.handleBulkCreateAccessorials}
            onHide={() =>
              this.setState({
                showBulkAccessorialModal: false,
                bulkAccessorialModalEditMode: false,
              })
            }
            edit={this.state.bulkAccessorialModalEditMode}
            selectedAccessorials={this.state.selectedAccessorialRequests.map(
              (acc) => acc._id,
            )}
          />
        )}
        <ConfirmModal
          dataTestId="ConfirmModal-68dfa1c1"
          show={this.state.showConfirmRemoveModal}
          title={t('CONFIRM_ACTION')}
          message={t('REMOVE_CARRIER_CONFIRMATION')}
          onHide={() => this.setState({ showConfirmRemoveModal: false })}
          onConfirm={this.removeCarrier}
        />
        <ConfirmModal
          dataTestId="ConfirmModal-2f9399c4"
          show={this.state.showConfirmModal}
          title={this.state.confirmModalTitle}
          message={this.state.confirmModalMessage}
          onHide={this.handleCancelConfirmModal}
          onConfirm={this.handleRemoveAdjustmentConfirm}
        />
        {this.state.showConfirmStateTransitionModal && (
          <ConfirmModal
            dataTestId="ConfirmModal-ef83f34b"
            show={this.state.showConfirmStateTransitionModal}
            title={t('STATUS_CHANGE_CONFIRMATION_TITLE')}
            message={this.getStateTransitionMessage(
              this.state.nextState.status,
            )}
            onHide={this.handleHideConfirmStateTransitionModal}
            onConfirm={() => this.handleConfirmStateTransitionModal()}
          />
        )}
        {this.state.accessorialAction && (
          <AccessorialsConfirmationModal
            show
            action={this.state.accessorialAction}
            onHide={() => this.setState({ accessorialAction: '' })}
            shipmentId={shipment._id}
            selectedAccessorials={this.state.selectedAccessorialRequests.map(
              (acc) => acc._id,
            )}
            onAccessorialSubmit={this.handleAccessorialOnSubmit}
            handleAccessorialRemove={this.handleAccessorialRemove}
          />
        )}
        {this.state.showHoldModal && (
          <ShipmentOnHoldModal
            hold={{}}
            setShowHoldModal={(show) => this.setShowHoldModal(show)}
            onSave={(hold) => this.onSaveHold(hold)}
            timezone={this.state.timezone}
            loading={this.state.isLoadingHolds}
          />
        )}
        {this.state.showSendFeesDueEmailModal && (
          <SendEmailModal
            action={t('SEND_FEES_DUE_PAYMENT_LINK')}
            show={this.state.showSendFeesDueEmailModal}
            onSend={(recipients) =>
              ShipmentWebAPIUtils.sendFeesDuePaymentLink(
                shipment._id,
                recipients,
              )
            }
            onHide={this.handleHideSendFeesDueEmailModal}
          />
        )}
        {this.state.showOverrideBillingStatusModal && (
          <OverrideBillingStatusModal
            shipmentIds={[shipment._id]}
            open={this.state.showOverrideBillingStatusModal}
            onHide={this.handleHideOverrideBillingStatusModal}
            onSuccess={() => this.refreshShipment()}
          />
        )}
        {this.state.showBillingStatusPendingReviewModal && (
          <BillingStatusPendingReviewModal
            shipmentIds={[shipment._id]}
            open={this.state.showBillingStatusPendingReviewModal}
            onHide={this.handleHideBillingStatusPendingReviewModal}
            onSuccess={() => this.refreshShipment()}
          />
        )}

        {/* Floating AI Button */}
        <FloatingAIAssistant shipmentId={shipment.shipment_id} />
      </div>
    );
  }

  setShowHoldModal = (show) => {
    this.setState({ showHoldModal: show });
  };

  onSaveHold = (hold) => {
    this.setState({ isLoadingHolds: true }, async () => {
      const { shipment } = this.state;
      const response = await addHold(shipment._id, hold);
      if (response) {
        // shipment.holds = response.holds;
        this.setState({ showHoldModal: false, isLoadingHolds: false });
        this.refreshShipment();
      }
    });
  };

  handleHideConfirmStateTransitionModal = () => {
    this.setState((prevState) => ({
      showConfirmStateTransitionModal:
        !prevState.showConfirmStateTransitionModal,
    }));
  };
}

Shipment.propTypes = {
  match: PropTypes.object,
};

export default withTranslation()(withLocaleContext(Shipment));

function getEquipmentList(shipment) {
  return _.uniq(
    shipment.stops.reduce(
      (equipmentList, stop) => equipmentList.concat(stop.equipments),
      [],
    ),
    (equipment) => equipment._id,
  );
}

function getIdParam(props) {
  const { modalID, match, shipment } = props;

  const params = (match || {}).params || {};
  return modalID || params.id || shipment._id;
}

const getAccessorialRequestIds = (requests) =>
  (requests || []).map((r) => r._id);

const getAccessorialRequestIdsWithMissingDocs = (requests) =>
  (requests || []).filter((r) => r.missing_docs).map((r) => r._id);
